export const GeneratorOff = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="#868C98"
      d="M6.856 11.404h2.643c.135 0 .245-.103.245-.23 0-.128-.11-.232-.245-.232H6.856c-.135 0-.245.104-.245.231 0 .128.11.23.245.23M10.285 10.942h-.005c-.136 0-.245.104-.245.231 0 .128.11.23.245.23h.005c.135 0 .245-.102.245-.23 0-.127-.11-.23-.245-.23M10.285 11.865H6.855c-.135 0-.245.104-.245.231s.11.23.245.23h3.429c.135 0 .245-.103.245-.23s-.11-.23-.245-.23M10.285 10.02H6.855c-.135 0-.245.103-.245.23 0 .128.11.231.245.231h3.429c.135 0 .245-.103.245-.23 0-.128-.11-.231-.245-.231M6.848 9.557h.008c.135 0 .245-.103.245-.23 0-.128-.11-.231-.245-.231h-.008c-.135 0-.245.103-.245.23 0 .128.11.231.245.231M7.607 9.557h2.678c.135 0 .245-.103.245-.23 0-.128-.11-.231-.245-.231H7.607c-.135 0-.245.103-.245.23 0 .128.11.231.245.231"
    />
    <path
      fill="#868C98"
      d="M15.505 15.27h-3.849v-.653c0-.276-.239-.502-.533-.502h-.385v-.733l.927-.382a.23.23 0 0 0 .146-.211v-.231h.735q.06-.001.11-.025l.979-.461a.23.23 0 0 0 .135-.207v-.346h1.225c.135 0 .245-.103.245-.23v-1.154c0-.128-.11-.231-.245-.231H13.77v-.346a.23.23 0 0 0-.135-.207l-.98-.461a.3.3 0 0 0-.11-.025h-.734v-.23a.23.23 0 0 0-.146-.212l-.98-.404A.3.3 0 0 0 10.587 8H6.548c-1.42 0-2.573 1.088-2.573 2.425v.573c0 1.307 1.102 2.376 2.477 2.423v.694h-.386c-.293 0-.532.226-.532.502v.652h-1.54c-.134 0-.244.104-.244.231v1.27c0 .127.11.23.245.23h11.51c.135 0 .245-.103.245-.23V15.5c0-.127-.11-.23-.245-.23m-1.735-4.905h.98v.693h-.98zm-.98-.895.49.23v2.023l-.49.23zm-.979-.143h.49v2.77h-.49zm-.156 5.942q0-.004 0 0M4.465 11v-.574c0-1.083.934-1.964 2.083-1.964h3.988l.786.324v3.852l-.786.324H6.548c-1.149 0-2.084-.88-2.084-1.963m5.783 2.424v.692H6.942v-.692zm-4.225 1.154h5.143v.692H6.023zm-.487.692h-.001q0-.004 0 0m9.724 1.27H4.24v-.808h11.02z"
    />
    <path
      stroke="#868C98"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.5"
      d="m20 11.75-1.5 1.5m0-1.5 1.5 1.5m1.75-.75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    />
  </svg>
);
